module.exports = __webpack_public_path__ + "static/keanu-reeves-efecc654623d2380f66be283b306970b.jpg";